import {ListEmitters} from '../../details-view/list-emitters';

/**
 * Created by wilk on 07.07.2017.
 */

export class SearchView extends ListEmitters {}
